import { Trans } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import type {
  InspectionResult,
  InspectionViewContext,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionResultSchema'
import type { ReportAssetSource } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/reportViewSchema'
import { lazy, Suspense, useMemo } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

const Model = lazy(() => import('./DocChatInspectionViewer'))
export function ReportAssetView({
  source,
  onViewContextChange,
}: {
  source: ReportAssetSource
  onViewContextChange?: (context: InspectionViewContext | null) => void
}) {
  const result = useMemo<InspectionResult>(
    () => ({
      kind: 'inspection_view',
      site_id: source.site_id,
      unit_id: source.unit_id,
      component_id: source.component_id,
      presentation: {
        title: source.title,
        layer: source.layer,
        mode: source.mode,
        focus: source.focus,
        show_features: true,
      },
      provenance: {
        inspection_id: source.inspection_id,
        dataset_id: source.dataset_id,
        asset_model_id: source.asset_model_id,
        dataset_generation: source.dataset_generation,
        asset_model_generation: source.asset_model_generation,
        column: source.column,
        bin_bounds: source.bin_bounds,
        as_of_date: source.as_of_date,
      },
    }),
    [source]
  )
  return (
    <ErrorBoundary
      fallback={
        <Text>
          <Trans>The inspection model is unavailable.</Trans>
        </Text>
      }>
      <Suspense
        fallback={
          <Text>
            <Trans>Loading inspection model…</Trans>
          </Text>
        }>
        <Model
          onViewContextChange={onViewContextChange}
          assetModelId={source.asset_model_id}
          inspectionId={source.inspection_id}
          datasetId={source.dataset_id}
          componentId={source.component_id}
          unitId={source.unit_id}
          siteId={source.site_id}
          result={result}
        />
      </Suspense>
    </ErrorBoundary>
  )
}
